import * as React from 'react';

export default class SearchIcon extends React.Component {
  render() {
    return React.createElement('svg', {
      className: this.props.className,
      viewBox: '0 0 18 19',
      dangerouslySetInnerHTML: {
        __html:
          '<path style="fill: #cccccc" d="M17.7,16.9l-5-5.4c0.9-1.1,1.4-2.5,1.4-4.1c0-3.7-3-6.7-6.7-6.7c-3.7,0-6.8,3-6.8,6.7s3,6.7,6.8,6.7c1.5,0,2.8-0.5,3.9-1.2l4.9,5.3c0.4,0.4,1,0.4,1.4,0.1C18,17.9,18,17.3,17.7,16.9z M7.3,12.2c-2.6,0-4.8-2.1-4.8-4.7c0-2.6,2.1-4.7,4.8-4.7c2.6,0,4.7,2.1,4.7,4.7C12.1,10.1,10,12.2,7.3,12.2z"/>',
      },
    });
  }
}
